import dayjs from 'dayjs';
import { parseDisplayDate } from './parseDisplayDate';

// Matches common date formats: YYYY-MM-DD, MM/DD/YYYY, with optional time/timezone suffix
const DATE_PATTERN = /^(\d{4}-\d{2}-\d{2}|\d{1,2}\/\d{1,2}\/\d{4})(T[\d:.]+([+-]\d{2}:\d{2}|Z)?)?$/;

export const isValidDate = (value: unknown): boolean => {
  if (value == null) return false;
  const str = String(value).trim();
  if (!str) return false;
  if (!DATE_PATTERN.test(str)) return false;
  return dayjs(str).isValid();
};

export const formatDate = (value: unknown): string => {
  if (!value) return '';
  const str = String(value).trim();
  if (!str) return '';
  try {
    const date = parseDisplayDate(str);
    if (!date) return str;
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  } catch {
    return str;
  }
};

export const formatImportDate = (value: unknown): string => {
  if (typeof value !== 'string' || !value.trim()) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString();
};
